<template>
    <div :class="['task-prop', 'task-prop_responsible', {'task-prop_corrupted': corrupted}]">
        <strong class="task-prop__label">Ответственный:</strong>
        <Select
            class="task-prop__value"
            :name="`responsible[]`"
            :items="users"
            :labelCallback="responsibleLabelCallback"
            :active="value"
            @selectChange="v => $emit('update', v)"
        />
    </div>
</template>

<script>
import {mapState} from "vuex";

export default {
    name: "Responsible",
    computed: {
        ...mapState({
            users: state => state.planUrlTask.users,
        }),
    },
    props: ['value', 'corrupted'],
    methods: {
        responsibleLabelCallback(user) {
            return (user.lastname || '') + ' ' + (user.firstname || '');
        },
    }
}
</script>

<style lang="scss">
.task-prop_responsible {
    .task-prop__label {
        margin-right: auto;
    }

    .task-prop__value {
        width: 100%;
        max-width: 250px;
    }
}
</style>
